import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { InfoDropdownList, InfoDropdownListItemButton } from "components/InfoDropdown"
import RequestLocation, { RequestLocationType } from "models/RequestLocation"
import InfoDropdownHeader from "components/InfoDropdown/InfoDropdownHeader"
import ShippingOrderLocationItem from "./ShippingOrderLocationItem"
import { Guid } from "@/types"

interface IShippingOrderModalBulkLocationsProps {
    locations: RequestLocation[] | null
    onSelectLocation: (locationId: Guid) => Promise<void>
    onAddLocationClick?: () => void
}

const ShippingOrderModalBulkLocations: FC<IShippingOrderModalBulkLocationsProps> = ({
    locations,
    onSelectLocation,
    onAddLocationClick,
}) => {
    const { t } = useTranslation()

    const requestLocations = useMemo(() => {
        if (!locations) return []
        return locations.filter(loc => loc.type === RequestLocationType.eventLocation || loc.type === RequestLocationType.userDefined)
    }, [locations])

    const warehouses = useMemo(() => {
        if (!locations) return []
        return locations.filter(loc => loc.type === RequestLocationType.warehouse)
    }, [locations])

    const renderLocationsList = (locs: RequestLocation[]) => {
        return locs.map(location => (
            <InfoDropdownListItemButton key={location.id}
                onClick={() => onSelectLocation(location.id)}>
                <ShippingOrderLocationItem
                    locations={locations}
                    locationId={location.id}
                    label={location.description}
                />
            </InfoDropdownListItemButton>
        ))
    }

    return (
        <InfoDropdownList>
            <InfoDropdownHeader title={t('shippingOrders.requestLocations')} />
            {renderLocationsList(requestLocations   )}
            {!!onAddLocationClick &&
                <InfoDropdownListItemButton onClick={onAddLocationClick}>
                    <ShippingOrderLocationItem
                        locations={locations}
                        label={t("shippingOrders.addRequestLocation")}
                    />
                </InfoDropdownListItemButton>
            }
            {warehouses.length > 0 &&
                <>
                    <InfoDropdownHeader title={t('shippingOrders.warehouses')} />
                    {renderLocationsList(warehouses)}
                </>
            }
        </InfoDropdownList>
    )
}

export default ShippingOrderModalBulkLocations
